// Note that some of these values are compared with integers inside shader code (converted to strings), so they need to be integers.
export enum SSFXRendererOutput {
  FINAL_RENDER_WITH_EFFECTS = 1,

  PICKING_IDS = 2,
  MATERIAL_ID = 3, // From the alternative material pass

  LINEWORK = 4,
  LINEWORK_WITH_SELECTION = 5,
  LINEWORK_TRANSPARENT = 6,

  UV_CALIBRATION = 7,

  NORMAL = 8,

  DEPTH = 10,
  DEPTH_MIP_1 = 11,
  DEPTH_MIP_2 = 12,
  DEPTH_MIP_3 = 13,
  DEPTH_MIP_4 = 14,
  DEPTH_MIP_5 = 15,
  DEPTH_MIP_6 = 16,
  DEPTH_MIP_7 = 17,
  DEPTH_MIP_8 = 18,
  DEPTH_MIP_9 = 19,
  DEPTH_MIP_10 = 20,

  AO = 21,
  NORMAL_FOR_AO = 22,

  LIGHT_PROBE_IRRADIANCE = 24,
  LIGHT = 25,
  LIGHT_WITHOUT_DETAIL = 26, // Same as "Light", but normal maps and material self-AO and self-shadowing are disabled.
  BASE_COLOR = 27, // Material color without lighting applied.
  SCREEN_SPACE_SHADOWS = 28,
  TRANSMISSION_VISUALIZATION = 29,

  MESH_ID = 30, // Assign random colors to individual meshes that normally use design materials.
}

export function ssfxRendererOutputName(output: SSFXRendererOutput): string {
  for (const [key, value] of Object.entries(SSFXRendererOutput)) {
    if (value === output) {
      return key;
    }
  }
  throw "Invalid SSFXRenderer output";
}

export function ssfxRendererOutputRequiresShadowMap(output: SSFXRendererOutput): boolean {
  switch (output) {
    case SSFXRendererOutput.PICKING_IDS:
    case SSFXRendererOutput.MATERIAL_ID:
    case SSFXRendererOutput.LINEWORK:
    case SSFXRendererOutput.LINEWORK_WITH_SELECTION:
    case SSFXRendererOutput.LINEWORK_TRANSPARENT:
    case SSFXRendererOutput.UV_CALIBRATION:
    case SSFXRendererOutput.NORMAL:
    case SSFXRendererOutput.DEPTH:
    case SSFXRendererOutput.DEPTH_MIP_1:
    case SSFXRendererOutput.DEPTH_MIP_2:
    case SSFXRendererOutput.DEPTH_MIP_3:
    case SSFXRendererOutput.DEPTH_MIP_4:
    case SSFXRendererOutput.DEPTH_MIP_5:
    case SSFXRendererOutput.DEPTH_MIP_6:
    case SSFXRendererOutput.DEPTH_MIP_7:
    case SSFXRendererOutput.DEPTH_MIP_8:
    case SSFXRendererOutput.DEPTH_MIP_9:
    case SSFXRendererOutput.DEPTH_MIP_10:
    case SSFXRendererOutput.AO:
    case SSFXRendererOutput.NORMAL_FOR_AO:
    case SSFXRendererOutput.LIGHT_PROBE_IRRADIANCE:
    case SSFXRendererOutput.BASE_COLOR:
    case SSFXRendererOutput.SCREEN_SPACE_SHADOWS:
    case SSFXRendererOutput.MESH_ID:
      return false;
    default:
      return true;
  }
}
